import { BaseDto } from './base.dto';

export class StockOrderDto extends BaseDto {
  stockOrderStatusId: number;
  supplierId: number;
  orderedDate: Date;
  deliveredDate: Date;
  notes: string;
}
